import { makeCRUDSlice } from '@redux/crudCreator';
import { confirmPick, MODEL_NAME, transferOrdersActions } from './actions';
import { pick } from 'lodash';

const slice = makeCRUDSlice(MODEL_NAME, transferOrdersActions, {
  [confirmPick.pending as any]: (state) => {
    state.loading = true;
    return state;
  },
  [confirmPick.fulfilled as any]: (state, { payload }) => {
    state.loading = false;
    state.currentData = {
      ...state.currentData,
      ...pick(payload, [
        'partner',
        'partnerId',
        'location',
        'locationId',
        'orderNoErp',
        'customerOrderId',
        'ghnOrderCode',
        'status',
        'statusOms',
      ]),
    };
    return state;
  },
  [confirmPick.rejected as any]: (state) => {
    state.loading = false;
    return state;
  },
});

export default slice.reducer;
